// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { css, StyleSheet } from 'aphrodite/no-important'
import { isNumber } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { LabelIcon } from '../../LabelIcon'

export default function ActualStockCell(props) {
  const { actualStock, deleted, expectedStock, onSelect, showExpectedStock } =
    props

  if (deleted) return null

  const alert = expectedStock !== actualStock
  const iconName =
    isNumber(expectedStock) && isNumber(actualStock) && showExpectedStock
      ? alert
        ? 'overdue'
        : 'tick-in-circle'
      : null

  return (
    <div
      onClick={onSelect}
      className={css(classes.actualStockCell, onSelect && classes.clickable)}
    >
      <LabelIcon
        iconPosition="right"
        iconFill={alert ? colors.orange : colors.successgreen}
        iconName={iconName}
        iconSize={24}
        text={actualStock}
      />
    </div>
  )
}

const classes = StyleSheet.create({
  actualStockCell: {
    display: 'flex',
    justifyContent: 'center'
  },
  clickable: {
    cursor: 'pointer'
  }
})

ActualStockCell.propTypes = {
  actualStock: PropTypes.number.isRequired,
  deleted: PropTypes.bool,
  expectedStock: PropTypes.number,
  onSelect: PropTypes.func,
  showExpectedStock: PropTypes.bool
}
